import json from "./site-content.json";
import type { SiteContent } from "./site-content.types";

// JSON literals widen to `string` on import, which defeats the discriminated
// union on `Section["type"]`. We cast through `unknown` to preserve call-site
// narrowing; the structural contract is verified at build time by
// `site-content.test.ts`.
export const siteContent = json as unknown as SiteContent;

export type { SiteContent, Section, Page, Seo } from "./site-content.types";
